import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, defineComponent, PropType, useAttrs } from 'vue';


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'SOptionGroup',
},
  __name: 'SOptionGroup',
  props: {
    indent: { type: Boolean, default: false }
  },
  setup(__props: any) {



const props = __props;

const classes = computed(() => {
  let result = 's-checkbox ';

  result += `${props.indent ? 's-checkbox--indent' : ''} `;

  return result;
});

return (_ctx: any,_cache: any) => {
  const _component_q_option_group = _resolveComponent("q-option-group")!

  return (_openBlock(), _createBlock(_component_q_option_group, {
    "keep-color": "",
    color: "brand",
    class: _normalizeClass(classes.value)
  }, null, 8, ["class"]))
}
}

})